import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { User } from '../interfaces/user.interface';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root',
})
export class UserService {
  private userSubject = new BehaviorSubject<User | null>(null);
  private tokenSubject = new BehaviorSubject<string | null>(null);

  user$ = this.userSubject.asObservable();
  token$ = this.tokenSubject.asObservable();

  constructor(private router: Router) {
    this.loadUserFromStorage();
    if (!this.isAuthenticated()) {
      this.clearUserData();
      this.router.navigate(['/login']);
    }
  }

  private loadUserFromStorage() {
    try {
      const savedUser = localStorage.getItem('user');
      const savedToken = localStorage.getItem('token');

      if (savedUser && savedToken) {
        this.userSubject.next(JSON.parse(savedUser));
        this.tokenSubject.next(savedToken);
      } else {
        this.userSubject.next(null);
        this.tokenSubject.next(null);
      }
    } catch (error) {
      this.clearUserData();
      throw new Error('Greška prilikom učitavanja korisnika' + error);
    }
  }

  getToken(): string | null {
    return this.tokenSubject.value;
  }

  setUser(user: User | null): void {
    this.userSubject.next(user);
    localStorage.setItem('user', JSON.stringify(user));
  }

  setToken(token: string): void {
    this.tokenSubject.next(token);
    localStorage.setItem('token', token);
  }

  clearUserData(): void {
    localStorage.removeItem('user');
    localStorage.removeItem('token');
    this.userSubject.next(null);
    this.tokenSubject.next(null);
  }

  isAuthenticated(): boolean {
    return !!this.tokenSubject.value;
  }
}
